import {
  PersonControllerActivity200Response,
  GetActivityLogDto,
  ActivityLogApiFp,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseActivityLogModel = PersonControllerActivity200Response;
export type GetActivityLogModel = GetActivityLogDto;

export const apiActivityLogFp = ActivityLogApiFp(apiConfig);
export const getActivityLogController =
  apiActivityLogFp.activityLogControllerGet;
export const getActivityLogByPatientController =
  apiActivityLogFp.activityLogControllerGetByPatient;

export const QueryKeyActivityLog = QueryKey.ActivityLog;
